import "@/css/components/loader.scss";
import Spinner from "@/svg/spinner-third-duotone.svg?react";
import classNames from "classnames";
import React from "react";

export default function Loader({className, ...props}: React.SVGAttributes<SVGSVGElement>) {
    return <Spinner className={classNames("loader", className)} {...props} />
}